import "./App.css";
import { ReactLogo } from "./components/ReactLogo";

import Tabla from "./pages/Tabla";

function App() {
  return (
    <div className="App">
      <br></br>
      <Tabla />
      <ReactLogo />
    </div>
  );
}

export default App;
